"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.RoleEnum = exports.NetworkEnum = exports.AreaOfLawEnum = exports.EmailTypeEnum = exports.PhoneTypeEnum = exports.CountryEnum = exports.StateEnum = exports.BranchType = exports.ActionEnum = exports.StatusEnum = void 0;
var StatusEnum;
(function (StatusEnum) {
    StatusEnum["CREATED"] = "CREATED";
    StatusEnum["ACTIVATED"] = "ACTIVATED";
    StatusEnum["DEACTIVATED"] = "DEACTIVATED";
    StatusEnum["DELETED"] = "DELETED";
})(StatusEnum = exports.StatusEnum || (exports.StatusEnum = {}));
var ActionEnum;
(function (ActionEnum) {
    ActionEnum["CREATE"] = "CREATE";
    ActionEnum["ACTIVATE_BRANCH"] = "ACTIVATE_BRANCH";
    ActionEnum["DEACTIVATE_BRANCH"] = "DEACTIVATE_BRANCH";
    ActionEnum["DELETE"] = "DELETE";
    ActionEnum["CHANGE"] = "CHANGE";
    ActionEnum["UPDATE_ADDRESS"] = "UPDATE_ADDRESS";
    ActionEnum["UPDATE_SERVICE_AREAS"] = "UPDATE_SERVICE_AREAS";
    ActionEnum["UPDATE_ABOUT_US_TEXT"] = "UPDATE_ABOUT_US_TEXT";
    ActionEnum["UPDATE_PERMISSIONS"] = "UPDATE_PERMISSIONS";
    ActionEnum["UPDATE_PHONES"] = "UPDATE_PHONES";
    ActionEnum["UPDATE_PROVIDER_IDS"] = "UPDATE_PROVIDER_IDS";
    ActionEnum["UPDATE_REFERRAL_PROVIDER_IDS"] = "UPDATE_REFERRAL_PROVIDER_IDS";
    ActionEnum["UPDATE_BRANCH_NAME"] = "UPDATE_BRANCH_NAME";
    ActionEnum["UPDATE_TIME_ZONE"] = "UPDATE_TIME_ZONE";
    ActionEnum["UPDATE_WEBSITE_URL"] = "UPDATE_WEBSITE_URL";
    ActionEnum["UPDATE_WELCOME_VIDEO_URL"] = "UPDATE_WELCOME_VIDEO_URL";
    ActionEnum["UPDATE_EMAIL_ADDRESS"] = "UPDATE_EMAIL_ADDRESS";
    ActionEnum["UPDATE_BRANCH_TYPES"] = "UPDATE_BRANCH_TYPES";
    ActionEnum["UPDATE_EXTERNAL_ID"] = "UPDATE_EXTERNAL_ID";
    ActionEnum["UPDATE_AREAS_OF_LAW"] = "UPDATE_AREAS_OF_LAW";
    ActionEnum["UPDATE_YEAR_FOUNDED"] = "UPDATE_YEAR_FOUNDED";
    ActionEnum["UPDATE_YEAR_JOINED"] = "UPDATE_YEAR_JOINED";
    ActionEnum["LINK_PROVIDER"] = "LINK_PROVIDER";
    ActionEnum["UNLINK_PROVIDER"] = "UNLINK_PROVIDER";
    ActionEnum["UPDATE_NETWORK"] = "UPDATE_NETWORK";
    ActionEnum["UPDATE_CASE_ID_PREFIX"] = "UPDATE_CASE_ID_PREFIX";
    ActionEnum["UPDATE_UNAVAILABLE_DATES"] = "UPDATE_UNAVAILABLE_DATES";
    ActionEnum["UPDATE_PROFILE_PICTURE_URL"] = "UPDATE_PROFILE_PICTURE_URL";
})(ActionEnum = exports.ActionEnum || (exports.ActionEnum = {}));
var BranchType;
(function (BranchType) {
    BranchType["PARTNER"] = "PARTNER";
    BranchType["REFERRAL"] = "REFERRAL";
    BranchType["OTHER"] = "OTHER";
})(BranchType = exports.BranchType || (exports.BranchType = {}));
var StateEnum;
(function (StateEnum) {
    StateEnum["AB"] = "AB";
    StateEnum["AK"] = "AK";
    StateEnum["AL"] = "AL";
    StateEnum["AR"] = "AR";
    StateEnum["AZ"] = "AZ";
    StateEnum["BC"] = "BC";
    StateEnum["CA"] = "CA";
    StateEnum["CA2"] = "CA_2";
    StateEnum["CO"] = "CO";
    StateEnum["CT"] = "CT";
    StateEnum["DC"] = "DC";
    StateEnum["DE"] = "DE";
    StateEnum["FL"] = "FL";
    StateEnum["GA"] = "GA";
    StateEnum["GU"] = "GU";
    StateEnum["HI"] = "HI";
    StateEnum["IA"] = "IA";
    StateEnum["ID"] = "ID";
    StateEnum["IL"] = "IL";
    StateEnum["IN"] = "IN";
    StateEnum["KS"] = "KS";
    StateEnum["KY"] = "KY";
    StateEnum["LA"] = "LA";
    StateEnum["LS"] = "LS";
    StateEnum["MA"] = "MA";
    StateEnum["MB"] = "MB";
    StateEnum["MD"] = "MD";
    StateEnum["ME"] = "ME";
    StateEnum["MI"] = "MI";
    StateEnum["MN"] = "MN";
    StateEnum["MO"] = "MO";
    StateEnum["MS"] = "MS";
    StateEnum["MT"] = "MT";
    StateEnum["NB"] = "NB";
    StateEnum["NC"] = "NC";
    StateEnum["ND"] = "ND";
    StateEnum["NE"] = "NE";
    StateEnum["NF"] = "NF";
    StateEnum["NH"] = "NH";
    StateEnum["NJ"] = "NJ";
    StateEnum["NL"] = "NL";
    StateEnum["NM"] = "NM";
    StateEnum["NS"] = "NS";
    StateEnum["NT"] = "NT";
    StateEnum["NU"] = "NU";
    StateEnum["NV"] = "NV";
    StateEnum["NY"] = "NY";
    StateEnum["OH"] = "OH";
    StateEnum["OK"] = "OK";
    StateEnum["ON"] = "ON";
    StateEnum["OR"] = "OR";
    StateEnum["PA"] = "PA";
    StateEnum["PE"] = "PE";
    StateEnum["PR"] = "PR";
    StateEnum["QC"] = "QC";
    StateEnum["RI"] = "RI";
    StateEnum["SC"] = "SC";
    StateEnum["SD"] = "SD";
    StateEnum["SF"] = "SF";
    StateEnum["SK"] = "SK";
    StateEnum["TN"] = "TN";
    StateEnum["TX"] = "TX";
    StateEnum["UT"] = "UT";
    StateEnum["VA"] = "VA";
    StateEnum["VI"] = "VI";
    StateEnum["VT"] = "VT";
    StateEnum["WA"] = "WA";
    StateEnum["WI"] = "WI";
    StateEnum["WV"] = "WV";
    StateEnum["WY"] = "WY";
    StateEnum["YT"] = "YT";
})(StateEnum = exports.StateEnum || (exports.StateEnum = {}));
var CountryEnum;
(function (CountryEnum) {
    CountryEnum["CAN"] = "CAN";
    CountryEnum["USA"] = "USA";
})(CountryEnum = exports.CountryEnum || (exports.CountryEnum = {}));
var PhoneTypeEnum;
(function (PhoneTypeEnum) {
    PhoneTypeEnum["OFFICE"] = "OFFICE";
    PhoneTypeEnum["TOLL_FREE"] = "TOLL_FREE";
    PhoneTypeEnum["FAX"] = "FAX";
    PhoneTypeEnum["TALKDESK_CALLER_ID"] = "TALKDESK_CALLER_ID";
    PhoneTypeEnum["OTHER"] = "OTHER";
})(PhoneTypeEnum = exports.PhoneTypeEnum || (exports.PhoneTypeEnum = {}));
var EmailTypeEnum;
(function (EmailTypeEnum) {
    EmailTypeEnum["DOCUMENTS"] = "DOCUMENTS";
    EmailTypeEnum["WILLS"] = "WILLS";
    EmailTypeEnum["PRIMARY"] = "PRIMARY";
    EmailTypeEnum["MANAGEMENT"] = "MANAGEMENT";
})(EmailTypeEnum = exports.EmailTypeEnum || (exports.EmailTypeEnum = {}));
var AreaOfLawEnum;
(function (AreaOfLawEnum) {
    AreaOfLawEnum["AM"] = "AM";
    AreaOfLawEnum["AD"] = "AD";
    AreaOfLawEnum["AF"] = "AF";
    AreaOfLawEnum["AA"] = "AA";
    AreaOfLawEnum["BK"] = "BK";
    AreaOfLawEnum["BR"] = "BR";
    AreaOfLawEnum["BD"] = "BD";
    AreaOfLawEnum["BT"] = "BT";
    AreaOfLawEnum["BS"] = "BS";
    AreaOfLawEnum["CU"] = "CU";
    AreaOfLawEnum["CS"] = "CS";
    AreaOfLawEnum["CL"] = "CL";
    AreaOfLawEnum["CC"] = "CC";
    AreaOfLawEnum["CO"] = "CO";
    AreaOfLawEnum["CN"] = "CN";
    AreaOfLawEnum["CF"] = "CF";
    AreaOfLawEnum["CT"] = "CT";
    AreaOfLawEnum["CY"] = "CY";
    AreaOfLawEnum["CP"] = "CP";
    AreaOfLawEnum["CD"] = "CD";
    AreaOfLawEnum["CR"] = "CR";
    AreaOfLawEnum["DE"] = "DE";
    AreaOfLawEnum["DI"] = "DI";
    AreaOfLawEnum["DU"] = "DU";
    AreaOfLawEnum["DV"] = "DV";
    AreaOfLawEnum["ED"] = "ED";
    AreaOfLawEnum["EL"] = "EL";
    AreaOfLawEnum["EM"] = "EM";
    AreaOfLawEnum["ET"] = "ET";
    AreaOfLawEnum["EP"] = "EP";
    AreaOfLawEnum["FL"] = "FL";
    AreaOfLawEnum["FW"] = "FW";
    AreaOfLawEnum["FA"] = "FA";
    AreaOfLawEnum["FC"] = "FC";
    AreaOfLawEnum["FR"] = "FR";
    AreaOfLawEnum["GA"] = "GA";
    AreaOfLawEnum["GL"] = "GL";
    AreaOfLawEnum["GC"] = "GC";
    AreaOfLawEnum["HL"] = "HL";
    AreaOfLawEnum["IT"] = "IT";
    AreaOfLawEnum["IM"] = "IM";
    AreaOfLawEnum["ID"] = "ID";
    AreaOfLawEnum["IN"] = "IN";
    AreaOfLawEnum["JV"] = "JV";
    AreaOfLawEnum["LL"] = "LL";
    AreaOfLawEnum["LT"] = "LT";
    AreaOfLawEnum["LM"] = "LM";
    AreaOfLawEnum["LN"] = "LN";
    AreaOfLawEnum["MM"] = "MM";
    AreaOfLawEnum["ML"] = "ML";
    AreaOfLawEnum["MR"] = "MR";
    AreaOfLawEnum["MD"] = "MD";
    AreaOfLawEnum["VD"] = "VD";
    AreaOfLawEnum["NC"] = "NC";
    AreaOfLawEnum["OG"] = "OG";
    AreaOfLawEnum["PC"] = "PC";
    AreaOfLawEnum["PT"] = "PT";
    AreaOfLawEnum["PN"] = "PN";
    AreaOfLawEnum["PD"] = "PD";
    AreaOfLawEnum["PI"] = "PI";
    AreaOfLawEnum["PA"] = "PA";
    AreaOfLawEnum["PU"] = "PU";
    AreaOfLawEnum["PR"] = "PR";
    AreaOfLawEnum["PL"] = "PL";
    AreaOfLawEnum["PY"] = "PY";
    AreaOfLawEnum["TA"] = "TA";
    AreaOfLawEnum["PS"] = "PS";
    AreaOfLawEnum["RE"] = "RE";
    AreaOfLawEnum["RC"] = "RC";
    AreaOfLawEnum["RF"] = "RF";
    AreaOfLawEnum["RP"] = "RP";
    AreaOfLawEnum["SC"] = "SC";
    AreaOfLawEnum["SS"] = "SS";
    AreaOfLawEnum["SN"] = "SN";
    AreaOfLawEnum["SL"] = "SL";
    AreaOfLawEnum["TX"] = "TX";
    AreaOfLawEnum["TS"] = "TS";
    AreaOfLawEnum["TM"] = "TM";
    AreaOfLawEnum["TR"] = "TR";
    AreaOfLawEnum["TU"] = "TU";
    AreaOfLawEnum["UA"] = "UA";
    AreaOfLawEnum["VE"] = "VE";
    AreaOfLawEnum["VA"] = "VA";
    AreaOfLawEnum["WC"] = "WC";
    AreaOfLawEnum["WD"] = "WD";
    AreaOfLawEnum["ZP"] = "ZP";
    AreaOfLawEnum["WL"] = "WL";
})(AreaOfLawEnum = exports.AreaOfLawEnum || (exports.AreaOfLawEnum = {}));
var NetworkEnum;
(function (NetworkEnum) {
    NetworkEnum["LEGALSHIELD"] = "LEGALSHIELD";
    NetworkEnum["CLC"] = "CLC";
})(NetworkEnum = exports.NetworkEnum || (exports.NetworkEnum = {}));
var RoleEnum;
(function (RoleEnum) {
    RoleEnum["ADMIN"] = "ADMIN";
    RoleEnum["CSR"] = "CSR";
    RoleEnum["LAWYER"] = "LAWYER";
    RoleEnum["RESOLUTION_LAWYER"] = "RESOLUTION_LAWYER";
    RoleEnum["RESOLUTION_CSR"] = "RESOLUTION_CSR";
    RoleEnum["REFERRAL_CLERK"] = "REFERRAL_CLERK";
    RoleEnum["PPLSI_MANAGEMENT"] = "PPLSI_MANAGEMENT";
    RoleEnum["INTAKES_VIEW"] = "INTAKES_VIEW";
    RoleEnum["DECOMMISSIONED_ADMIN"] = "DECOMMISSIONED_ADMIN";
})(RoleEnum = exports.RoleEnum || (exports.RoleEnum = {}));
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../utils");
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://branches.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Branches Service Api
 * @version v1
 * @baseUrl https://branches.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesGetBranchesByOwner
             * @request GET:/v1/branches
             * @secure
             */
            branchesGetBranchesByOwner: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesCreateBranch
             * @request POST:/v1/branches
             * @secure
             */
            branchesCreateBranch: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesGetSpecificBranch
             * @request GET:/v1/branches/{branchId}
             * @secure
             */
            branchesGetSpecificBranch: (branchId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesDeleteResource
             * @request DELETE:/v1/branches/{branchId}
             * @secure
             */
            branchesDeleteResource: (branchId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesGetBranchesByList
             * @request POST:/v1/branches/getBranchesByIdList
             * @secure
             */
            branchesGetBranchesByList: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/getBranchesByIdList`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateAddress
             * @request POST:/v1/branches/{branchId}/updateAddress
             * @secure
             */
            branchesUpdateAddress: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateAddress`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateServiceAreas
             * @request POST:/v1/branches/{branchId}/updateServiceAreas
             * @secure
             */
            branchesUpdateServiceAreas: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateServiceAreas`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateAboutUsText
             * @request POST:/v1/branches/{branchId}/updateAboutUsText
             * @secure
             */
            branchesUpdateAboutUsText: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateAboutUsText`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdatePhones
             * @request POST:/v1/branches/{branchId}/updatePhones
             * @secure
             */
            branchesUpdatePhones: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updatePhones`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateProviderIds
             * @request POST:/v1/branches/{branchId}/updateProviderIds
             * @secure
             */
            branchesUpdateProviderIds: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateProviderIds`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesAddProviderId
             * @request POST:/v1/branches/{branchId}/addProviderId
             * @secure
             */
            branchesAddProviderId: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/addProviderId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesRemoveProviderId
             * @request POST:/v1/branches/{branchId}/removeProviderId
             * @secure
             */
            branchesRemoveProviderId: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/removeProviderId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateReferralProviderIds
             * @request POST:/v1/branches/{branchId}/updateReferralProviderIds
             * @secure
             */
            branchesUpdateReferralProviderIds: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateReferralProviderIds`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateName
             * @request POST:/v1/branches/{branchId}/updateName
             * @secure
             */
            branchesUpdateName: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateName`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateEmailAddress
             * @request POST:/v1/branches/{branchId}/updateEmailAddress
             * @deprecated
             * @secure
             */
            branchesUpdateEmailAddress: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateEmailAddress`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateEmails
             * @request POST:/v1/branches/{branchId}/updateEmails
             * @secure
             */
            branchesUpdateEmails: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateEmails`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateEmail
             * @request POST:/v1/branches/{branchId}/updateEmail
             * @secure
             */
            branchesUpdateEmail: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateEmail`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesAddEmail
             * @request POST:/v1/branches/{branchId}/addEmail
             * @secure
             */
            branchesAddEmail: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/addEmail`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesRemoveEmail
             * @request POST:/v1/branches/{branchId}/removeEmail
             * @secure
             */
            branchesRemoveEmail: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/removeEmail`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateWebsiteUrl
             * @request POST:/v1/branches/{branchId}/updateWebsiteUrl
             * @secure
             */
            branchesUpdateWebsiteUrl: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateWebsiteUrl`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateWelcomeVideoUrl
             * @request POST:/v1/branches/{branchId}/updateWelcomeVideoUrl
             * @secure
             */
            branchesUpdateWelcomeVideoUrl: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateWelcomeVideoUrl`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateIdentityPermissions
             * @request POST:/v1/branches/{branchId}/updateIdentityPermissions
             * @secure
             */
            branchesUpdateIdentityPermissions: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateIdentityPermissions`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdatePermissions
             * @request POST:/v1/branches/{branchId}/updatePermissions
             * @secure
             */
            branchesUpdatePermissions: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updatePermissions`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesOverwritePermissions
             * @request POST:/v1/branches/{branchId}/permissions/{identityId}
             * @secure
             */
            branchesOverwritePermissions: (branchId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/permissions/${identityId}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesRemovePermission
             * @request POST:/v1/branches/{branchId}/removePermission
             * @secure
             */
            branchesRemovePermission: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/removePermission`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesRemovePermissions
             * @request POST:/v1/branches/{branchId}/removePermissions
             * @secure
             */
            branchesRemovePermissions: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/removePermissions`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateTimeZone
             * @request POST:/v1/branches/{branchId}/updateTimeZone
             * @secure
             */
            branchesUpdateTimeZone: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateTimeZone`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateBranchTypes
             * @request POST:/v1/branches/{branchId}/updateBranchTypes
             * @secure
             */
            branchesUpdateBranchTypes: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateBranchTypes`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateExternalId
             * @request POST:/v1/branches/{branchId}/updateExternalId
             * @secure
             */
            branchesUpdateExternalId: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateExternalId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateAreasOfLaw
             * @request POST:/v1/branches/{branchId}/updateAreasOfLaw
             * @secure
             */
            branchesUpdateAreasOfLaw: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateAreasOfLaw`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateYearFounded
             * @request POST:/v1/branches/{branchId}/updateYearFounded
             * @secure
             */
            branchesUpdateYearFounded: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateYearFounded`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateYearJoined
             * @request POST:/v1/branches/{branchId}/updateYearJoined
             * @secure
             */
            branchesUpdateYearJoined: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateYearJoined`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesActivate
             * @request POST:/v1/branches/{branchId}/activate
             * @secure
             */
            branchesActivate: (branchId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/activate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesDeactivate
             * @request POST:/v1/branches/{branchId}/deactivate
             * @secure
             */
            branchesDeactivate: (branchId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/deactivate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateNetwork
             * @request POST:/v1/branches/{branchId}/updateNetwork
             * @secure
             */
            branchesUpdateNetwork: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateNetwork`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateCaseIdPrefix
             * @request POST:/v1/branches/{branchId}/updateCaseIdPrefix
             * @secure
             */
            branchesUpdateCaseIdPrefix: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateCaseIdPrefix`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesAddUnavailableDate
             * @request POST:/v1/branches/{branchId}/addUnavailableDate
             * @secure
             */
            branchesAddUnavailableDate: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/addUnavailableDate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesRemoveUnavailableDate
             * @request POST:/v1/branches/{branchId}/removeUnavailableDate
             * @secure
             */
            branchesRemoveUnavailableDate: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/removeUnavailableDate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateUnavailableDate
             * @request POST:/v1/branches/{branchId}/updateUnavailableDates
             * @secure
             */
            branchesUpdateUnavailableDate: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateUnavailableDates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateProfilePictureUrl
             * @request POST:/v1/branches/{branchId}/updateProfilePictureUrl
             * @secure
             */
            branchesUpdateProfilePictureUrl: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateProfilePictureUrl`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BranchesJournal
             * @name BranchesJournalGetJournalChanges
             * @request GET:/v1/branches/journal
             * @secure
             */
            branchesJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BranchesJournal
             * @name BranchesJournalGetMaxClock
             * @request GET:/v1/branches/journal/maxClock
             * @secure
             */
            branchesJournalGetMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;
//# sourceMappingURL=branches.js.map